__turbopack_context__.v({
  "address": "CreateListPanel-module-scss-module__mxg8Qq__address",
  "address__intro": "CreateListPanel-module-scss-module__mxg8Qq__address__intro",
  "consultant": "CreateListPanel-module-scss-module__mxg8Qq__consultant",
  "consultant__actions": "CreateListPanel-module-scss-module__mxg8Qq__consultant__actions",
  "field": "CreateListPanel-module-scss-module__mxg8Qq__field",
  "form": "CreateListPanel-module-scss-module__mxg8Qq__form",
  "row": "CreateListPanel-module-scss-module__mxg8Qq__row",
  "section-label": "CreateListPanel-module-scss-module__mxg8Qq__section-label",
  "sheet": "CreateListPanel-module-scss-module__mxg8Qq__sheet",
  "success": "CreateListPanel-module-scss-module__mxg8Qq__success",
  "success__link": "CreateListPanel-module-scss-module__mxg8Qq__success__link",
});
